import * as React from "react";
const SvgFiRrFolderXmark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 3h-6.53c-.15 0-.31-.04-.45-.11L8.86 1.31C8.45 1.1 7.98.99 7.52.99H4.99A5.015 5.015 0 0 0 0 6v12c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V8c0-2.76-2.24-5-5-5M5 3h2.53c.15 0 .31.04.45.11l3.16 1.58c.41.21.88.32 1.34.32h6.53c1.3 0 2.42.84 2.83 2H2v-1c0-1.65 1.35-3 3-3zm14 18H5c-1.65 0-3-1.35-3-3V9h20v9c0 1.65-1.35 3-3 3m-3.79-7.79L13.42 15l1.79 1.79a.996.996 0 0 1-.71 1.7c-.26 0-.51-.1-.71-.29L12 16.41l-1.79 1.79c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41L10.58 15l-1.79-1.79a.996.996 0 1 1 1.41-1.41l1.79 1.79 1.79-1.79a.996.996 0 1 1 1.41 1.41z"
    />
  </svg>
);
export default SvgFiRrFolderXmark;
